const TAG_ERROR_CODE = {
  TAG_001: 'TAG001',
  TAG_002: 'TAG002',
  TAG_003: 'TAG003',
  TAG_004: 'TAG004',
  TAG_005: 'TAG005',
};

const TAG_ERROR_MESSAGE = {
  [TAG_ERROR_CODE.TAG_001]: '태그 id는 1이상의 정수형만 가능합니다',
  [TAG_ERROR_CODE.TAG_002]: '태그 상태는 활성, 비활성 만 가능합니다.',
  [TAG_ERROR_CODE.TAG_003]: '태그 제목은 문자열 형식입니다.',
  [TAG_ERROR_CODE.TAG_004]: 'url 소유 여부는 boolean 만 가능합니다.',
  [TAG_ERROR_CODE.TAG_005]: 'TAG id 를 찾을 수 없습니다.',
};

export default TAG_ERROR_MESSAGE;
